module.exports = __webpack_public_path__ + "static/media/cloud.225d364d.svg";